"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWallet = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconWallet = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M20.885 7.81h-2.15V5.331h-14.3v14.3h14.3v-2.479h2.15v4.63h-18.6v-18.6h18.6V7.81Zm-10.45 9.871v-10.4h11.45v10.4h-11.45Zm5.2-3.7a1.45 1.45 0 0 0 1.063-.437 1.45 1.45 0 0 0 .437-1.063c0-.416-.146-.77-.437-1.062a1.447 1.447 0 0 0-1.063-.438c-.416 0-.77.146-1.062.438a1.446 1.446 0 0 0-.438 1.062c0 .417.146.771.438 1.063.291.291.646.437 1.062.437Zm4.1 1.55v-6.1h-7.15v6.1h7.15Z"
}));
exports.IconWallet = IconWallet;
//# sourceMappingURL=IconWallet.js.map